import React, {Component} from 'react';
import {
    injectStripe,
    PostalCodeElement, CardNumberElement, CardExpiryElement, CardCVCElement
} from 'react-stripe-elements';
import '../css/subscription-page.css';
import axios from 'axios';
import {backendDomain} from "../modules/configs";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import uuidv4 from 'uuid/v4';
import {startFetchingInvoiceList} from "../actions/getSubscriptions";
import {
    cancelSubscription, chooseInterval, chooseTier,
    startFetchingSubscriptionList
} from "../actions/getSubscriptions";
import PopupMessage from '../components/popup-message';
import LoadingAnimation from '../components/loading-animation';
import {CountryDropdown, RegionDropdown} from 'react-country-region-selector';
import Moment from 'moment';

class InvoiceList extends Component {
    render() {
        const {loadingInvoiceList, invoiceList} = this.props;
        if (loadingInvoiceList) {
            return <LoadingAnimation/>
        }

        return <div className="invoiceTableContainer">
            <table className="invoiceTable">
                <thead>
                <tr>
                    <th className="set-th">Date</th>
                    <th className="set-th">Product</th>
                    <th className="set-th">Amount</th>
                </tr>
                </thead>
                <tbody>
                {invoiceList && invoiceList.length > 0 ? this.composeInvoiceList(invoiceList) :
                    <tr>
                        <td>No Payments</td>
                    </tr>}
                </tbody>
            </table>
        </div>
    }

    composeInvoiceList(invoiceList) {
        const trListOfInvoices = [];
        invoiceList.forEach((invoiceItem, ind) => {
            const {date, charge, planName, total} = invoiceItem;
            let dateString = Moment.unix(date).format("MM/DD/YYYY");
            let totalInDollarFormat = `$ ${total / 100}`;
            trListOfInvoices.push(
                <tr key={ind}>
                    <td className="sub-td">{dateString}</td>
                    <td className="sub-td">{planName}</td>
                    <td className="sub-td">{totalInDollarFormat}</td>

                </tr>
            )
        })
        return trListOfInvoices;
    }
}

/**
 * Name constants (prefix, suffix) of subscription
 */
export const TIER_RANKS_PREFIX = {
    TIER0: 'TIER0',
    TIER1: 'TIER1',
    TIER2: 'TIER2'
}
export const INTERVAL_NAMES_SUFFIX = {
    MONTHLY: 'MONTHLY',
    YEARLY: 'YEARLY'
}

/**
 * Mapping: tier index to its displayed name
 */
export const TIER_DISPLAYED_NAME = {
    TIER0: 'Basic',
    TIER1: 'Premium',
    TIER2: 'Pro'
}

export const PRICE_IN_DOLLARS_BY_TIER = {
    TIER0: '0',
    TIER1_MONTHLY: '9',
    TIER2_MONTHLY: '19',
    TIER1_YEARLY: '99',
    TIER2_YEARLY: '209'
}

/**
 * price tag of corresponding tier
 */
export const PRICE_TAG_BY_TIER = {
    TIER0: 'Free',
    TIER1_MONTHLY: '$9/month',
    TIER2_MONTHLY: '$19/month',
    TIER1_YEARLY: '$99/year',
    TIER2_YEARLY: '$209/year'
}

export const TRIAL_TIME_BY_TIER = {
    TIER0: '',
    TIER1: '30 days free trial',
    TIER2: '30 days free trial'
}

// TODO: make light box messages
export const TIER_DESCRIPTION = {
    TIER0: <span className='description'>SprintRay Resin Validation<br/>
    Other Repairs<br/>
    View & Filter Recent Job Parameters<br/>
    Monitor Resin Use History<br/>
    Live Status Update<br/>
    </span>,
    TIER1: <span className='description'>Advanced Scan Repair<br/>
    Plane Cut<br/>
    Export to .STL<br/>
    SprintRay Resin Validation<br/>
    Other Repairs<br/>
    View & Filter Recent Job Parameters<br/>
    Monitor Resin Use History<br/>
    Live Status Update<br/>
    </span>,
    TIER2: <span className='description'>3rd Party Resin Validation<br/>
    Advanced Scan Repair<br/>
    Plane Cut<br/>
    Export to .STL<br/>
    SprintRay Resin Validation<br/>
    Other Repairs<br/>
    View & Filter Recent Job Parameters<br/>
    Monitor Resin Use History<br/>
    Live Status Update<br/>
    </span>
}

/**
 * Page where subscription occurs
 */
class SubscriptionPage extends Component {
    constructor(props) {
        super(props);
        // State used to store additional card info
        this.state = {
            name: "",
            lastName: "",
            address_line1: "",
            address_line2: "",
            address_city: "",
            address_state: "",
            address_country: "",
            promo_code: "",
            discount: "",
            termsAndConditionsAccepted: ""
        }
        this.idempotentKey = uuidv4();
        this.popupMessage = null;
    }

    render() {
        const {loadingSubscriptionList, chosenInterval, chosenTierRank, subscriptionList, chooseInterval, chooseTier, loadingInvoiceList, invoiceList} = this.props;
        return <div>
            {
                loadingSubscriptionList ? <LoadingAnimation/> :
                    <div className="checkout">
                        <div>
                            <h3><b>Select Plan</b></h3>

                            <TierPicker
                                chooseTier={this.updateChosenTier.bind(this)}
                                chosenTierRank={chosenTierRank}/>

                            <hr/>
                            <div className="card-row">
                                <div className="card-col-25">
                                    <h3><b>Payment Terms</b></h3>
                                </div>

                                <IntervalPicker
                                    chooseInterval={this.updateChosenInterval.bind(this)}
                                    chosenTierRank={chosenTierRank}
                                    chosenInterval={chosenInterval}/>

                                <PaymentForm
                                    { ...this.props }
                                    address_country={this.state.address_country}
                                    address_state={this.state.address_state}
                                    updateAdditionalCardInfo={this.updateAdditionalCardInfo.bind(this)}
                                    selectCountry={this.selectCountry.bind(this)}
                                    selectRegion={this.selectRegion.bind(this)}
                                    submitPaymentInfo={this.submitPaymentInfo.bind(this)}
                                    applyPromoCode={this.applyPromoCode.bind(this)}
                                    discount = {this.state.discount}
                                    updateTermsAndConditionsAccepted = {this.updateTermsAndConditionsAccepted.bind(this)}
                                />
                            </div>

                            <hr/>

                            <div className='invoices-container'>
                                <div className='invoices-title'><b>Invoices</b></div>
                                <InvoiceList loadingInvoiceList={loadingInvoiceList} invoiceList={invoiceList}/>
                            </div>

                        </div>
                    </div>
            }
            <PopupMessage ref={(element) => this.popupMessage = element}/>
        </div>
    }

    componentDidMount(tier) {
        this.props.startFetchingInvoiceList();
    }

    updateChosenInterval(interval){
        const {chooseInterval} = this.props
        this.setCurrentDiscountState(0)
        chooseInterval(interval)
    }

    updateChosenTier(tier){
        const {chooseTier} = this.props
        this.setCurrentDiscountState(0)
        chooseTier(tier)
    }

    updateAdditionalCardInfo(ev) {
        this.setState({[ev.target.name]: ev.target.value});
    }

    updateTermsAndConditionsAccepted(ev) {
        this.setState({termsAndConditionsAccepted: ev.target.checked})
    }

    selectCountry(val) {
        this.setState({address_country: val});
    }

    selectRegion(val) {
        this.setState({address_state: val});
        this.addLastNameToName();
    }

    addLastNameToName() {
        this.setState({name: this.state.name + " " + this.state.lastName})
    }

    setCurrentDiscountState = (value) => {
        this.setState({discount: value})
    }

    async applyPromoCode(ev){
        ev.preventDefault();
        const {promo_code} = this.state
        const {chosenInterval} = this.props
        let postData = {promo_code, chosenInterval};
        const res = await axios.post(`${backendDomain}/subscription/promo`, postData,
            {headers: {Authorization: `Bearer ${localStorage.getItem('access_token')}`}});
        if (res.data !== "Invalid") {
            this.setCurrentDiscountState(res.data)
            this.popupMessage.alert("Promo Code successfully applied!")
        }
        else this.popupMessage.alert("Invalid Promo Code")
    }

    async submitPaymentInfo(ev) {
        ev.preventDefault();
        const idempotentKey = this.idempotentKey;
        const {planFullName, hasSubscription, chosenTierRank} = this.props;
        const {promo_code} = this.state
        let subscriptionId;
        if (this.props.subscriptionList[0]) {
            subscriptionId = this.props.subscriptionList[0].id;
        } else {
            subscriptionId = "";
        }
        let submitAction, postData, successMessage;

        if (chosenTierRank === TIER_RANKS_PREFIX.TIER0) {
            postData = {subscriptionId};
            submitAction = 'cancel';
            successMessage = 'Subscription canceled. Your plan will continue to be active through the end of the pre-paid period.'
        }
        /** Show payment form all the time, instead of storing cards and updates **/
        else if (hasSubscription) {
            const {name, address_line1, address_line2, address_city, address_state, address_country, termsAndConditionsAccepted} = this.state
            const token = await this.props.stripe.createToken({
                name,
                address_line1,
                address_line2,
                address_city,
                address_state,
                address_country
            });
            if (!token.token)
                return this.popupMessage.alert('Payment information is incorrect or missing. Please ensure all information is entered correctly.');
            if (!termsAndConditionsAccepted)
                return this.popupMessage.alert('Please accept terms and conditions.');
            const cardToken = token.token.id;
            postData = {newPlanFullName: planFullName, idempotentKey, subscriptionId, cardToken};
            submitAction = 'update';
            successMessage = 'Subscription updated successfully.'
        }
        else {
            const {name, address_line1, address_line2, address_city, address_state, address_country, termsAndConditionsAccepted} = this.state
            const token = await this.props.stripe.createToken({
                name,
                address_line1,
                address_line2,
                address_city,
                address_state,
                address_country
            });
            if (!token.token)
                return this.popupMessage.alert('Payment information is incorrect or missing. Please ensure all information is entered correctly.');
            if (!termsAndConditionsAccepted)
                return this.popupMessage.alert('Please accept terms and conditions.');
            const cardToken = token.token.id;
            postData = {cardToken, planFullName, idempotentKey, promo_code};
            submitAction = 'create';
            successMessage = 'Subscription updated successfully.'
        }

        const res = await axios.post(`${backendDomain}/subscription/${submitAction}`, postData,
            {headers: {Authorization: `Bearer ${localStorage.getItem('access_token')}`}});
        if (res.status === 200) {
            this.popupMessage.alert(successMessage, () => {
                this.props.startFetchingSubscriptionList();
            });
        }
        else this.popupMessage.alert("Subscription Failed! Please contact support.")
    }
}

/**
 * Section to choose a tier
 */
const TierPicker = ({chooseTier, chosenTierRank}) => {
    return (<div className='plan-chooser'>
        <TierCard tierRankName='TIER0'
                  onClick={() => chooseTier('TIER0')}
                  chosenTierRank={chosenTierRank}/>
        {TIER_RANKS_PREFIX[chosenTierRank] === 'TIER1' &&
        <TierCard tierRankName='TIER1'
                  onClick={() => chooseTier('TIER1')}
                  chosenTierRank={chosenTierRank}/>}
        <TierCard tierRankName='TIER2'
                  onClick={() => chooseTier('TIER2')}
                  chosenTierRank={chosenTierRank}/>
    </div>)
}

const TierCard = ({tierRankName, chosenTierRank, onClick}) => {
    return <div className={`plan-card${tierRankName === TIER_RANKS_PREFIX[chosenTierRank] ? ' plan-card-chosen' : ''}`}
                onClick={onClick}>
        <div className='plan-name'>{TIER_DISPLAYED_NAME[tierRankName]}</div>
        <div className='plan-card-description-container'>
            <div className='plan-description'>{TIER_DESCRIPTION[tierRankName]}</div>
            <hr/>
            <div className='price-description-container'>
                <div className='plan-description'>{TRIAL_TIME_BY_TIER[tierRankName]}</div>
                <div className='monthly-price'>
                    {PRICE_TAG_BY_TIER[`${tierRankName}_${INTERVAL_NAMES_SUFFIX.MONTHLY}`] || PRICE_TAG_BY_TIER[tierRankName]}
                    <b>{tierRankName === TIER_RANKS_PREFIX.TIER0 ? ' ' : ' OR '}</b>
                    {PRICE_TAG_BY_TIER[`${tierRankName}_${INTERVAL_NAMES_SUFFIX.YEARLY}`]}
                </div>
                <div className='yearly-price'>

                </div>
            </div>
        </div>
    </div>
}

/**
 * Section for customer to choose a plan
 */
const IntervalPicker = ({chooseInterval, chosenTierRank, chosenInterval}) => {
    const interval = INTERVAL_NAMES_SUFFIX[chosenInterval];
    return <div className={`interval-picker ${chosenTierRank === TIER_RANKS_PREFIX.TIER0 ? 'hidden' : ''}`}>
        <div className='interval-select'>
            <div
                className={`payment-term-toggle ${interval === INTERVAL_NAMES_SUFFIX.MONTHLY ? `payment-term-toggle-on` : ''}`}
                onClick={() => chooseInterval(INTERVAL_NAMES_SUFFIX.MONTHLY)}
            >
                Monthly
            </div>
            <div
                className={`payment-term-toggle ${interval === INTERVAL_NAMES_SUFFIX.YEARLY ? `payment-term-toggle-on` : ''}`}
                onClick={() => chooseInterval(INTERVAL_NAMES_SUFFIX.YEARLY)}
            >
                Yearly
            </div>
        </div>
    </div>
}

export class PaymentForm extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {planFullName, chosenTierRank, subscribedPlanFullName, hasSubscription, subscriptionList,
            updateAdditionalCardInfo, selectCountry, selectRegion, submitPaymentInfo, applyPromoCode, discount, updateTermsAndConditionsAccepted} = this.props;
        let hasSubscribedToThisPlan;
        if (subscribedPlanFullName) {
            hasSubscribedToThisPlan =
                planFullName === subscribedPlanFullName;
        }
        else {
            hasSubscribedToThisPlan =
                planFullName === TIER_RANKS_PREFIX.TIER0;
        }
        const isSubscriptionCancelled = hasSubscription && subscriptionList[0].cancel_at_period_end;
        const country = this.props.address_country;
        const region = this.props.address_state;

        const AlreadySubscribedMessage = () => <div className='already-subscribed-message'>You have already subscribed
            to this plan</div>;

        if (chosenTierRank === TIER_RANKS_PREFIX.TIER0 && isSubscriptionCancelled) {
            return <AlreadySubscribedMessage/>;
        }

        if (hasSubscribedToThisPlan && !isSubscriptionCancelled) {
            return <AlreadySubscribedMessage/>;
        }

        if (chosenTierRank === TIER_RANKS_PREFIX.TIER0 && hasSubscription) {
            return <button type="submit" value="Pay and Subscribe" onClick={submitPaymentInfo}
                           className="update-card-btn">Update Plan</button>
        }

        const isFormHidden = /*planFullName === null || */
            chosenTierRank === TIER_RANKS_PREFIX.TIER0;
        return (
            <div className="card-container">
                <form hidden={isFormHidden}>
                    <div className="card-row">
                        <div className="card-col-50">
                            <label htmlFor="ccnum">Credit/Debit Card Number</label>
                            <div className='payment-form-input'>
                                <CardNumberElement/>
                            </div>
                        </div>
                        <div className="card-col-25">
                            <label htmlFor="expyear">Expiration</label>
                            <div className='payment-form-input'>
                                <CardExpiryElement/>
                            </div>
                        </div>
                        <div className="card-col-25">
                            <label htmlFor="cvv">CVC</label>
                            <div className='payment-form-input'>
                                <CardCVCElement/>
                            </div>
                        </div>
                    </div>
                    <div className="card-row">
                        <div className="card-col-50">
                            <label htmlFor="first">First Name</label>
                            <input type="text" placeholder='First Name' name='name' className='payment-form-input'
                                   onChange={updateAdditionalCardInfo}/>
                        </div>
                        <div className="card-col-50">
                            <label htmlFor="last">Last Name</label>
                            <input placeholder='Last Name' name='lastName' className='payment-form-input'
                                   onChange={updateAdditionalCardInfo} type="text"/>
                        </div>
                    </div>
                    <div className="card-row">
                        <div className="card-col-50">
                            <label htmlFor="adr">Billing Address Line 1</label>
                            <input type="text" placeholder="Address" className='payment-form-input'
                                   name='address_line1' onChange={updateAdditionalCardInfo}/>
                        </div>
                        <div className="card-col-50">
                            <label htmlFor="adr">Billing Address Line 2 (optional)</label>
                            <input type="text" placeholder="Apt, Suite,..." className='payment-form-input'
                                   name='address_line2' onChange={updateAdditionalCardInfo}/>
                        </div>
                    </div>
                    <div className="card-row">
                        <div className="card-col-25">
                            <label htmlFor="zip">Country</label>
                            <CountryDropdown
                                value={country}
                                onChange={(val) => selectCountry(val)}
                            />
                        </div>
                        <div className="card-col-25">
                            <label htmlFor="zip">City</label>
                            <input type="text" placeholder="City" name='address_city' className='payment-form-input'
                                   onChange={updateAdditionalCardInfo}/>
                        </div>
                        <div className="card-col-25">
                            <label htmlFor="zip">State</label>
                            <RegionDropdown
                                country={country}
                                value={region}
                                onChange={(val) => selectRegion(val)}
                            />
                        </div>
                        <div className="card-col-25">
                            <label htmlFor="zip">Zip</label>
                            <div className='payment-form-input'>
                                <PostalCodeElement/>
                            </div>
                        </div>
                    </div>
                    <div className="card-row">
                        <div className="card-col-25">
                            <label htmlFor="promo">Promo Code</label>
                            <input type="text" placeholder='Enter Promo Code' name='promo_code' className='payment-form-input'
                                   onChange={updateAdditionalCardInfo}/>
                        </div>
                        <button type="submit" value="Apply" onClick={applyPromoCode}
                                className="promo-card-btn">Apply Promo Code
                        </button>
                    </div>
                    <div className="card-row">
                        <div className="card-col-50">
                            <input type="checkbox" name="termsAndConditionsAccepted" onChange={updateTermsAndConditionsAccepted} /> I agree to <a href="/terms-and-conditions" target="_blank">SprintRay's Terms and Conditions.</a>
                        </div>
                    </div>
                    <div className='price-and-btn'>
                        <div>Total Amount Due Today: <span>{'$' + String(PRICE_IN_DOLLARS_BY_TIER[planFullName] - PRICE_IN_DOLLARS_BY_TIER[planFullName] * 0.01 * discount)}</span></div>
                        <button type="submit" value="Pay and Subscribe" onClick={submitPaymentInfo}
                                className="card-btn">Pay and Subscribe
                        </button>
                    </div>
                </form>
            </div>
        )
    }
}


/**
 * Redux connection
 */
const mapStateToProps = state => ({
    userProfile: state.userProfile.profile,
    ...state.subscriptions
})
const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        chooseInterval,
        chooseTier,
        cancelSubscription,
        startFetchingSubscriptionList,
        startFetchingInvoiceList
    }, dispatch)
}
export default injectStripe(connect(mapStateToProps, mapDispatchToProps)(SubscriptionPage));



// WEBPACK FOOTER //
// ./src/containers/subscription-container.js